"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderActionButtons = exports.withTogglePressed = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const toggle_controller_1 = require("@/controllers/toggle-controller");
/**
 * bookmark-button·follow-button처럼 pressed 상태를 토글하고 'change'로 알리는
 * 시맨틱 버튼이 공유하는 pressed/value/disabled 상태와 토글 배선.
 */
const withTogglePressed = (Base) => {
    class TogglePressedElement extends Base {
        constructor() {
            super(...arguments);
            this.pressed = false;
            this.value = '';
            this.disabled = false;
            this.toggle = new toggle_controller_1.ToggleController(this, 'pressed');
        }
        handleToggleClick() {
            this.toggle.toggle();
        }
    }
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean })
    ], TogglePressedElement.prototype, "pressed", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], TogglePressedElement.prototype, "value", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean })
    ], TogglePressedElement.prototype, "disabled", void 0);
    return TogglePressedElement;
};
exports.withTogglePressed = withTogglePressed;
/**
 * primaryAction·secondaryAction을 받는 컴포넌트가 공유하는 버튼 쌍 조립 규칙.
 * secondary(tertiary)를 앞에, primary를 뒤에 두어 mm-button-group으로 묶고, 둘 다 없으면 그리지 않는다.
 * 그룹은 항상 stretch라 폭을 가진 자리(sheet-footer)에서는 행을 나눠 채우고, 내용 폭으로 줄어드는 자리에서는 내용 폭을 유지한다.
 */
function renderActionButtons({ primaryAction, secondaryAction, size = 'medium', }) {
    if (!primaryAction && !secondaryAction)
        return lit_1.nothing;
    return (0, lit_1.html) `
    <mm-button-group stretch>
      ${renderActionButton(secondaryAction, 'tertiary', size)}
      ${renderActionButton(primaryAction, 'primary', size)}
    </mm-button-group>
  `;
}
exports.renderActionButtons = renderActionButtons;
function renderActionButton(action, variant, size) {
    if (!action)
        return lit_1.nothing;
    return (0, lit_1.html) `
    <mm-button
      variant=${variant}
      size=${size}
      ?disabled=${action.disabled}
      @click=${() => action.onClick?.()}
    >
      ${action.label}
    </mm-button>
  `;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnV0dG9uLnV0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYnV0dG9uLnV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUErQztBQUMvQyxxREFBNEM7QUFNNUMsdUVBQWtFO0FBU2xFOzs7R0FHRztBQUNJLE1BQU0saUJBQWlCLEdBQUcsQ0FBb0MsSUFBTyxFQUFFLEVBQUU7SUFDOUUsTUFBTSxvQkFBcUIsU0FBUSxJQUFJO1FBQXZDOztZQUMrQixZQUFPLEdBQUcsS0FBSyxDQUFBO1lBQ2hCLFVBQUssR0FBRyxFQUFFLENBQUE7WUFDVCxhQUFRLEdBQUcsS0FBSyxDQUFBO1lBQ3JDLFdBQU0sR0FBZ0MsSUFBSSxvQ0FBZ0IsQ0FBQyxJQUFJLEVBQUUsU0FBUyxDQUFDLENBQUE7UUFLckYsQ0FBQztRQUhDLGlCQUFpQjtZQUNmLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxFQUFFLENBQUE7UUFDdEIsQ0FBQztLQUNGO0lBUjhCO1FBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQzt5REFBZ0I7SUFDaEI7UUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3VEQUFXO0lBQ1Q7UUFBNUIsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxDQUFDOzBEQUFpQjtJQVEvQyxPQUFPLG9CQUFzRCxDQUFBO0FBQy9ELENBQUMsQ0FBQTtBQWJZLFFBQUEsaUJBQWlCLHFCQWE3QjtBQVFEOzs7O0dBSUc7QUFDSCxTQUFnQixtQkFBbUIsQ0FBQyxFQUNsQyxhQUFhLEVBQ2IsZUFBZSxFQUNmLElBQUksR0FBRyxRQUFRLEdBQ007SUFDckIsSUFBSSxDQUFDLGFBQWEsSUFBSSxDQUFDLGVBQWU7UUFBRSxPQUFPLGFBQU8sQ0FBQTtJQUV0RCxPQUFPLElBQUEsVUFBSSxFQUFBOztRQUVMLGtCQUFrQixDQUFDLGVBQWUsRUFBRSxVQUFVLEVBQUUsSUFBSSxDQUFDO1FBQ3JELGtCQUFrQixDQUFDLGFBQWEsRUFBRSxTQUFTLEVBQUUsSUFBSSxDQUFDOztHQUV2RCxDQUFBO0FBQ0gsQ0FBQztBQWJELGtEQWFDO0FBRUQsU0FBUyxrQkFBa0IsQ0FDekIsTUFBZ0MsRUFDaEMsT0FBc0IsRUFDdEIsSUFBZ0I7SUFFaEIsSUFBSSxDQUFDLE1BQU07UUFBRSxPQUFPLGFBQU8sQ0FBQTtJQUUzQixPQUFPLElBQUEsVUFBSSxFQUFBOztnQkFFRyxPQUFPO2FBQ1YsSUFBSTtrQkFDQyxNQUFNLENBQUMsUUFBUTtlQUNsQixHQUFHLEVBQUUsQ0FBQyxNQUFNLENBQUMsT0FBTyxFQUFFLEVBQUU7O1FBRS9CLE1BQU0sQ0FBQyxLQUFLOztHQUVqQixDQUFBO0FBQ0gsQ0FBQyJ9